export enum GroupTypeModel {
  ALL = 1,
  OPERATIONAL = 2,
  SUPERVISION = 3,
  VALIDATION = 4,
  NONERPCOMPTABILITY = 5,
  ADMINISTRATION = 6,
  CONTROL = 7,
  OBSERVATION = 8,
  APPROVAL = 9,
  ANALYTICAL = 10,
  ORDEROPERATIONAL = 11,
  OPERATIONCONTRIBUTOR = 12,
  PPR_VALIDATION = 13,
  PPR_CANCELATION = 14,
  BACKUP = 15
}
